import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Service from '@/service/index.js';
import HomeService from '../service.js';
import Query from '../query/index.vue';
import TransactionProService from '@/views/transaction-pro/transaction-pro-service';
import { mapGetters } from 'vuex';

export default {
  components: {
    swiper,
    swiperSlide,
    Query
  },
  data() {
    return {
      projectType: [],
      hoverIndex: -1,
      hoverIndexPurchase: -1,
      purchaseProjectType: [],
      // projectTypeList: [{ name: '交易公告' }, { name: '采购公告' }],
      activeItem: 2, // 2采购 1流转
      projectList: [],
      purchaseList: [],
      projectStatusList: [],
      projectStatus: [],
      purchaseStatusList: [],
      purchaseStatus: [],
      status: null,
      transferProject: { activeIndex: 1, activePurchaseIndex: 1 },
      filterQuery: {},
      subTypeMap: {}, // 获取子类title
      swiperOption: {
        loop: false,
        slidesPerView: 5
      },
      tableList: [], // 流转
      tableListPurchase: [], // 采购
      qualificationReview: [], // 资格候审集合
      transctionProjectType: [], // 选择类型集合
      payWayList: [], // 支付方式
      projectSubTypeArr: [], // 项目子分类集合
      nearList: {
        // city:'',
        // county:'',
        township: '',
        village: '',
        pageNum: 1,
        pageSize: 6,
        status: ''
      }
    };
  },
  computed: {
    ...mapGetters([
      'projectTypeList',
      'isSignin'
    ]),
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    // if(!this.isSignin) {
    //   this.$router.push('/signin');
    //   return;
    // }
    this.getDictionarySelect();
    this.getProjectList();
    this.getPurchaseList();
    this.getQualificationReview();
    this.getPayType();
    this.gettransctionProjectStatus();
  },
  methods: {
    // 采购列表
    getPurchaseList(code) {
      // 如果点击附近项目 需要登录状态
      if(code === 4 && !this.isSignin) {
        console.log(1);
        this.$router.push('/signin');
        return;
      }
      if(code === 4 && this.isSignin) {
        this.nearByPurchaseList();
        return;
      }
      let form = { projectType: code, pageSize: 6, ...this.filterQuery};
      this.getPurchaseStatusList().then( () => {
        HomeService.getPurchaseList({
          ...form
        }).then(res => {
          if (res.code === '0') {
            res.data.list.forEach(item => {
              item.showStatus = item.status;
              // 已成交的状态
              if(Number(item.signStatus) === 0) {
                if(70 <= item.status && item.status <= 90) {
                  item.showStatus = 70;
                } else if(item.status === 92 ||item.status === 93 || item.status === 94 || item.status === 95 || item.status === 51){
                  item.showStatus = 95;// 已结束的状态
                }
              } else {
                item.showStatus = 50;
              }
            });
            this.tableListPurchase = res.data && res.data.list;
          }
        });
      });
    },
    // 采购项目-附近项目
    nearByPurchaseList() {
      // 获取用户账户信息
      this.nearList.status=this.purchaseStatusList;
      HomeService.getUserBaseInfo().then(res => {
        if (res && res.code === '0') {
          this.nearList.city = res.data.city;
          this.nearList.county = res.data.county;
          this.nearList.township = res.data.township;
          this.nearList.village = res.data.village;
        }
        this.getPurchaseStatusList().then( () => {
          HomeService.getnearByPurchaseList(this.nearList).then(res => {
            if (res.code === '0') {
              res.data.list.forEach(item => {
                item.showStatus = item.status;
                // 已成交的状态
                if(Number(item.signStatus) === 0) {
                  if(70 <= item.status && item.status <= 90) {
                    item.showStatus = 70;
                  } else if(item.status === 92 ||item.status === 93 || item.status === 94 || item.status === 95 || item.status === 51){
                    item.showStatus = 95;// 已结束的状态
                  }
                } else {
                  item.showStatus = 50;
                }
              });
              this.tableListPurchase = res.data && res.data.list;
            }
          });
        });
      });

    },
    // 采购状态对应字典
    getPurchaseStatusList() {
      return new Promise((resolve, reject) => {
        if (this.purchaseStatusList.length > 0) {
          resolve();
        } else {
          HomeService.getPurchaseStatusList().then(res => {
            if (res && res.code === '0') {
              this.purchaseStatus = res.data.purchaseList;
              this.purchaseStatusList = res.data.purchaseList.map(item => item.code);
              resolve();
            } else {
              reject();
            }
          }, () => {
            reject();
          });
        }
      });
    },

    hoverItem(index) {
      this.hoverIndex = index;
    },
    hoverItemPurchase(index) {
      this.hoverIndexPurchase = index;
    },
    // 流转字典
    getProjectStatus() {
      return new Promise((resolve, reject) => {
        if (this.projectStatusList.length > 0) {
          resolve();
        } else {
          HomeService.getProjectStatusList().then(res => {
            if (res && res.code === '0') {
              this.status = res.data.purchaseList;
              this.projectStatusList = res.data.purchaseList.map(item => item.code);
              resolve();
            } else {
              reject();
            }
          }, () => {
            reject();
          });
        }
      });
    },
    // 获取流转列表
    getProjectList(code) {
      // 如果点击附近项目 需要登录状态
      if(code === 9 && !this.isSignin) {
        console.log(1);
        this.$router.push('/signin');
        return;
      }
      if(code === 9 && this.isSignin) {
        this.getNearProjectList();
        return;
      }
      this.getProjectStatus().then(() => {
        HomeService.getProjectList({
          projectType: code,
          pageSize: 6,
          pageNum: 1,
          ...this.filterQuery
        }).then(res => {
          if (res.code === '0') {
            res.data.list.forEach(item => {
              item.showStatus = item.status;
              if(Number(item.signStatus) === 0) {
                // 已成交的状态
                if(70 <= item.status && item.status <= 90) {
                  item.showStatus = 70;
                } else if(item.status === 92 ||item.status === 93 || item.status === 94 || item.status === 95 || item.status === 51){
                  item.showStatus = 95;// 已结束的状态
                }
              } else {
                item.showStatus = 50;
              }
              // this.showProjectSubtype(item.projectType, item.projectSubType);
            });
            this.tableList = res.data && res.data.list;
            // this.publishProjectService(res.data.list[0].projectType);
          }
        });
      });
    },

    // 获取附近项目列表
    getNearProjectList() {
      // 获取用户账户信息
      this.nearList.status=this.purchaseStatusList;
      HomeService.getUserBaseInfo().then(res => {
        if (res && res.code === '0') {
          this.nearList.city = res.data.city;
          this.nearList.county = res.data.county;
          this.nearList.township = res.data.township;
          this.nearList.village = res.data.village;
        }
        this.getProjectStatus().then(() => {
          HomeService.getselectNearbyTradePro(this.nearList).then(res => {
            if (res.code === '0') {
              res.data.list.forEach(item => {
                item.showStatus = item.status;
                if(Number(item.signStatus) === 0) {
                  // 已成交的状态
                  if(70 <= item.status && item.status <= 90) {
                    item.showStatus = 70;
                  } else if(item.status === 92 ||item.status === 93 || item.status === 94 || item.status === 95 || item.status === 51){
                    item.showStatus = 95;// 已结束的状态
                  }
                } else {
                  item.showStatus = 50;
                }
              });
              this.tableList = res.data && res.data.list;
            }
          });
        });
      });

    },
    // 获取当前大类的子类 解决子类与大类对应不上的问题
    showProjectSubtype(type) {
      // console.log(type, subType, 'type, subType');
      TransactionProService.getProjectSubType(type).then(res => {
        if (res && res.code === '0') {
          res.data.map(item => {
            this.subTypeMap[type + '-' + item.code] = item.value;
          });
          this.subTypeMap= {...this.subTypeMap};
        }
      });
    },
    // 集体采购显示图片
    getProjectType (type) {
      if (type === 1) {
        return require('@/assets/images/common/engineering1.png');
      } else if (type === 2) {
        return require('@/assets/images/common/goods1.png');
      } else {
        return require('@/assets/images/common/service1.png');
      }
    },
    // 状态相对应的颜色
    getProjectStatusStyle (status) {
      if (status === 42) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #004B7C';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if (status === 70 || status === 95) {
        return 'background: #383838';
      }
    },
    // 采购的资格候审
    getQualificationReview () {
      Service.getSelectList('QUALIFICATION_REVIEW').then(res => {
        if (res && res.code === '0') {
          this.qualificationReview = res.data;
        }
      });
    },
    // 获取支付方式
    getPayType () {
      Service.getSelectList('PAY_TYPE').then(res => {
        if (res && res.code === '0') {
          this.payWayList = res.data;
        }
      });
    },
    // 获取项目类型
    gettransctionProjectStatus () {
      this.transctionProjectType = this.projectTypeList;
      // Service.getSelectList('PROJECT_TYPE').then(res => {
      //   if (res && res.code === '0') {
      //     this.transctionProjectType = res.data;
      //   }
      // });
    },
    // 获取项目子分类的集合
    publishProjectService(type) {
      HomeService.getProjectSubType(type).then(res => {
        if (res && res.code === '0') {
          this.projectSubTypeArr = res.data;
        }
      });
    },
    getDictionarySelect() {
      this.projectList = [
        {code: '1', value: '耕地'},
        {code: '2', value: '林地'},
        {code: '3', value: '水面'},
        {code: '4', value: '四荒'},
        {code: '5', value: '集体建设用地'},
        {code: '6', value: '房屋'},
        {code: '7', value: '设备设施'},
        {code: '8', value: '其他'},
        {code: '9', value: '附近项目'}
      ];
      this.projectList.forEach(v => { v.code = Number(v.code); });
      this.projectList = [{value: '全部', code: ''}, ...this.projectList];
      // console.log(res.data, 'res.data');
      this.projectList.forEach(v => {
        if (v.code) {
          v.img1 = require(`@/assets/images/home/project/${v.code}_1.png`);
          v.img2 = require(`@/assets/images/home/project/${v.code}_2.png`);
        } else {
          v.img1 = require('@/assets/images/home/project/all1.png');
          v.img2 = require('@/assets/images/home/project/all2.png');
        }
      });
      // Service.getSelectList('PROJECT_TYPE').then(res => {
      //   if (res && res.code === '0') {
      //     res.data = [
      //       {code: '1', value: '耕地'},
      //       {code: '2', value: '林地'},
      //       {code: '3', value: '水面'},
      //       {code: '4', value: '四荒'},
      //       {code: '5', value: '集体建设用地'},
      //       {code: '6', value: '房屋'},
      //       {code: '7', value: '设备设施'},
      //       {code: '8', value: '其他'}
      //     ];
      //     res.data.forEach(v => { v.code = Number(v.code); });
      //     res.data = [{value: '全部', code: ''}, ...res.data];
      //     res.data.forEach(v => {
      //       if (v.code) {
      //         v.img1 = require(`@/assets/images/home/project/${v.code}_1.png`);
      //         v.img2 = require(`@/assets/images/home/project/${v.code}_2.png`);
      //       } else {
      //         v.img1 = require('@/assets/images/home/project/all1.png');
      //         v.img2 = require('@/assets/images/home/project/all2.png');
      //       }
      //     });
      //     this.projectList = res.data;
      //   }
      // });
      this.purchaseList = [
        {code: '1', value: '工程建设'},
        {code: '2', value: '货物'},
        {code: '3', value: '服务'},
        {code: '4', value: '附近项目'}
      ];
      this.purchaseList.forEach(v => { v.code = Number(v.code); });
      this.purchaseList = [{value: '全部', code: ''}, ...this.purchaseList];
      // console.log(this.purchaseList, 'this.purchaseList');
      // this.purchaseList.forEach(v2 => {
      //   if (v2.code) {
      //     v2.img1 = require(`@/assets/images/home/project/purchase-${v2.code}_1.png`);
      //     v2.img2 = require(`@/assets/images/home/project/purchase-${v2.code}_2.png`);
      //   } else {
      //     v2.img1 = require('@/assets/images/home/project/all1.png');
      //     v2.img2 = require('@/assets/images/home/project/all2.png');
      //   }
      // });
      // Service.getSelectList('PURCHASE_PROJECT_TYPE').then(res => {
      //   if (res && res.code === '0') {
      //     res.data.forEach(v => { v.code = Number(v.code); });
      //     res.data = [{value: '全部', code: ''}, ...res.data];
      //     // console.log(res.data, 'res.data');
      //     res.data.forEach(v => {
      //       if (v.code) {
      //         v.img1 = require(`@/assets/images/home/project/purchase-${v.code}_1.png`);
      //         v.img2 = require(`@/assets/images/home/project/purchase-${v.code}_2.png`);
      //       } else {
      //         v.img1 = require('@/assets/images/home/project/all1.png');
      //         v.img2 = require('@/assets/images/home/project/all2.png');
      //       }
      //     });
      //     this.purchaseList = res.data;
      //   }
      // });
    },

    // 选择项目类型
    chooseProject(index, code, type) {
      if (type === 1) {
        this.transferProject.activeIndex = index;
        this.getProjectList(code);
      } else {
        this.transferProject.activePurchaseIndex = index;
        this.getPurchaseList(code);
        this.status = this.purchaseStatus;
      }
    },
    // 获取更多项目信息
    getMore(activeItem) {
      if (activeItem === 1) {
        this.$router.push('/transaction-pro/list');
      } else {
        this.$router.push('/collective-purchasing/list');
      }
    },
    // swiper左右切换
    prev() {
      this.swiper.slidePrev();
    },
    next() {
      this.swiper.slideNext();
    },
    rowClick(row) {
      if (this.activeItem === 1) {
        window.open(window.location.origin + '/#/transaction-pro/detail?id=' + row.projectId);
      } else {
        window.open(window.location.origin + '/#/collective-purchasing/detail?id=' + row.purchaseId);
      }
    },
    goToDetail (type, id, status) {
      if (type === 1) {
        window.open(window.location.origin + '/#/transaction-pro/detail?id=' + id + '&status=' +status);
      } else {
        window.open(window.location.origin + '/#/collective-purchasing/detail?id=' + id + '&status=' +status);
      }
    }
  }
};

